var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimmerSwitches01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2.97,13.45 2.62,13.09 12.36,3.33 12.71,3.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "12.48,3.09 13.2,2.73 12.89,3.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.06,4.38 11.63,2.95 14.17,1.68  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9,
    cy: 7.07,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9,9.3c-1.23,0-2.23-1-2.23-2.23c0-1.23,1-2.23,2.23-2.23s2.23,1,2.23,2.23C11.23,8.3,10.23,9.3,9,9.3z  M9,5.08c-1.09,0-1.98,0.89-1.98,1.98c0,1.09,0.89,1.98,1.98,1.98s1.98-0.89,1.98-1.98C10.98,5.97,10.09,5.08,9,5.08z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimmerSwitches01);
export default __webpack_public_path__ + "static/media/DimmerSwitches-01.4079c865b93d4471aef014cff8d38061.svg";
export { ForwardRef as ReactComponent };